export const days = [
  { text: 'Wtorek', value: 'Wtorek' },
  { text: 'Środa', value: 'Środa' },
  { text: 'Czwartek', value: 'Czwartek' },
  { text: 'Piątek', value: 'Piątek' },
  { text: 'Sobota', value: 'Sobota' },
  { text: 'Niedziela', value: 'Niedziela' },
];

export const categories = [
  { name: 'organizatorzy', color: '#b10000' },
  { name: 'poi', color: '#005C53' },
  { name: 'kije', color: '#006dff' },
  { name: 'hula', color: '#d5009b' },
  { name: 'aerial', color: '#b39cdd' },
  { name: 'wachlarze', color: '#93dbe6' },
  { name: 'żonglerka', color: '#ffbf48' },
  { name: 'inne kuglarskie', color: '#92b996' },
  { name: 'inne niekuglarskie', color: '#928e8f' },
  { name: 'W.U.R', color: '#6B21BF' },
  // { name: 'turniej domów', color: '#F9A881' },
  { name: 'busking', color: '#F9A881' },
  { name: 'spotkania do finału', color: '#d35b5b' },
];

export const categoryColors = Object.fromEntries(
  categories.map((c) => [c.name, c.color])
);

// kategorie, dla których pole 'Miejsce' nie jest wymagane
export const optionalLocationCategories = ['organizatorzy'];

// kategorie, dla których pole 'Prowadzący' nie jest wymagane
export const optionalInstructorCategories = ['organizatorzy', 'busking'];
